import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type {
  TConversionPair,
  TConversionPairServer,
  TConversionPairRate,
  TConversionPairRateServer,
} from '../../store/types';

const conversionPairItemAdapter = (item: TConversionPairServer): TConversionPair => ({
  id: item.id,
  baseCurrency: item.base_currency,
  quoteCurrency: item.quote_currency,
  rate: item.rate,
  rateUpdatedAt: dayjsCustom(item.rate_updated_at).format('DD.MM.YYYY / HH:mm'),
  markupPercent: item.markup_percent,
  conversionRate: item.conversion_rate,
  autoRefresh: item.auto_refresh,
});

export const conversionPairsAdapter = (items: TConversionPairServer[]): TConversionPair[] => (
  items.map(conversionPairItemAdapter)
);

export const conversionPairRateAdapter = (item: TConversionPairRateServer): TConversionPairRate => ({
  rate: item.rate,
});
